import { isNaN } from 'lodash'

const isDateValid = (dateValue: string | Date) => {
  return !isNaN(new Date(dateValue).getTime())
}

export default isDateValid
